import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import fromPairs from '~/shared/utils/fromPairs';

import { i18nContext, I18nContext } from './index';
import type { LocalizationData, LocalizedResources, Translations } from './types';

export interface PageWrapperProps {
  pageContext: Partial<I18nContext> & {
    frontmatter?: {
      locale?: string;
    };
  };
}

interface PageElementWrapperProps extends PageWrapperProps {
  element: React.ReactElement;
}

export function PageElementWrapper({ element, pageContext }: PageElementWrapperProps) {
  const data = useStaticQuery(graphql`
    query SharedWrapPageElement {
      allLocalization {
        nodes {
          locale
          translations {
            key
            value
          }
        }
      }
    }
  `);

  const locale = pageContext.locale ?? pageContext.frontmatter?.locale;
  const queriedTranslations = React.useMemo(() => {
    const l10ns: LocalizationData[] = data.allLocalization.nodes;

    return fromPairs(
      l10ns.map(({ locale, translations }) => [
        locale,
        fromPairs(translations.map(({ key, value }) => [key, value])) as LocalizedResources,
      ]),
    ) as Translations;
  }, [data.allLocalization.nodes]);
  const translations = pageContext.translations ?? queriedTranslations;

  if (!locale || !translations) {
    return element;
  }

  return <i18nContext.Provider value={{ locale, translations }}>{element}</i18nContext.Provider>;
}
